import {
  PeopleOutlineTwoTone,
  BadgeTwoTone,
  LocalShippingTwoTone,
  ShoppingCartTwoTone,
  Inventory2TwoTone,
  CurrencyRupeeTwoTone,
  AccountBalanceWalletTwoTone,
  PollTwoTone,
  ReceiptLongTwoTone,
  StorefrontTwoTone,
  Diversity1TwoTone,
  CheckCircleTwoTone,
  PaymentTwoTone,
  LabelTwoTone,
  LocalMallTwoTone,
  DocumentScannerTwoTone,
  FolderOpenTwoTone,
  Add,
} from "@mui/icons-material";
import { ReactNode } from "react";

interface ListItemType {
  name: string;
  icon: ReactNode;
  path?: string;
  sublists?: ListItemType[];
  permissions?: string[];
  is_cta?: boolean;
}

const NAVBAR_OPTIONS: ListItemType[] = [
  {
    name: "New Bill",
    icon: <Add />,
    path: "/billing/new",
    permissions: ["NEW_BILL"],
    is_cta: true,
  },
  {
    name: "Home",
    icon: <StorefrontTwoTone />,
    path: "/",
    permissions: [],
  },
  {
    name: "People",
    icon: <PeopleOutlineTwoTone />,
    sublists: [
      {
        name: "Customers",
        icon: <Diversity1TwoTone />,
        path: "/people/customers",
        permissions: ["CUSTOMERS"]
      },
      {
        name: "Staff",
        icon: <BadgeTwoTone />,
        path: "/people/staff",
        permissions: ["IS_ADMIN"]
      },
      {
        name: "Suppliers",
        icon: <LocalShippingTwoTone />,
        path: "/people/suppliers",
        permissions: ["SUPPLIERS"]
      },
    ],
  },
  {
    name: "Inventory",
    icon: <Inventory2TwoTone />,
    sublists: [
      {
        name: "Products",
        icon: <ShoppingCartTwoTone />,
        path: "/inventory/products",
        permissions: ["INVENTORY"]
      },
      {
        name: "Add Inventory",
        icon: <LocalShippingTwoTone />,
        path: "/inventory/add",
        permissions: ["INVENTORY"]
      },
    ],
  },
  {
    name: "Sales",
    icon: <LocalMallTwoTone />,
    sublists: [
      {
        name: "New Bill",
        icon: <ReceiptLongTwoTone />,
        path: "/billing/new",
        permissions: ["NEW_BILL"]
      },
      {
        name: "Old Bills",
        icon: <FolderOpenTwoTone />,
        path: "/billing/old",
        permissions: ["OLD_BILLS"]
      },
    ],
  },
  {
    name: "Reports",
    icon: <PollTwoTone />,
    permissions: ["REPORTS"],
    sublists: [
      {
        name: "Sales Overview",
        icon: <PollTwoTone />,
        path: "/reports/sales/",
        permissions: ["REPORTS"]
      },
      {
        name: "By Day",
        icon: <PollTwoTone />,
        path: "/reports/day/",
        permissions: ["REPORTS"]
      },
      {
        name: "GST Report",
        icon: <PollTwoTone />,
        path: "/reports/gst/",
        permissions: ["REPORTS"]
      },
      {
        name: "Sales Calendar",
        icon: <PollTwoTone />,
        path: "/reports/calendar/",
        permissions: ["REPORTS"]
      },
      {
        name: "Customer Location Insight",
        icon: <PollTwoTone />,
        path: "/reports/area/",
        permissions: ["REPORTS"]
      },
    ],
  },
  {
    name: "Accounting",
    icon: <CurrencyRupeeTwoTone />,
    permissions: ["ACCOUNTS"],
    sublists: [
      {
        name: "Overview",
        icon: <CheckCircleTwoTone />,
        path: "/accounting/overview",
        permissions: ["ACCOUNTS"]
      },
      {
        name: "Accounts",
        icon: <AccountBalanceWalletTwoTone />,
        path: "/accounting/accounts",
        permissions: ["ACCOUNTS"]
      },
      {
        name: "Labels",
        icon: <LabelTwoTone />,
        path: "/accounting/labels",
        permissions: ["ACCOUNTS"]
      },
      {
        name: "Payment Methods",
        icon: <PaymentTwoTone />,
        path: "/accounting/methods",
        permissions: ["ACCOUNTS"]
      },
    ],
  },
  {
    name: "Store Management",
    icon: <StorefrontTwoTone />,
    permissions: ["IS_ADMIN"],
    sublists: [
      {
        name: "Bill Layout",
        icon: <DocumentScannerTwoTone />,
        path: "/store/bill-layout",
        permissions: ["IS_ADMIN"]
      },
    ],
  },
];

export default NAVBAR_OPTIONS;
